<template>
  <div class="report" v-if="load">
    <report-menu v-model="date"></report-menu>
    <div class="main">
      <h2 class="main-title">Оплата</h2>
      <div class="main-header flex-justify">
        <div class="inner-addon">
        </div>
        <div class="header-right">

          <div class="select" >
            <select v-model="limit">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <section>
        <header>
          <div class="col-td">Дата</div>
          <div class="col-td">Операція</div>
          <div class="col-td">СУМА (₴)</div>
        </header>
        <div class="table-row first-row">
          <div class="col-td">ВСЬОГО ОПЛАТ</div>
          <div class="col-td"></div>
          <div class="col-td">{{total.totalSum | toCurrency }}</div>
        </div>

        <template  v-for="(tr, i) in payments" >
          <div class="table-row" :key="i">
            <div class="col-td desktop" style="width: 20%" >{{tr.datePay | formatOnlyDate }}</div>
            <div class="col-td desktop"  style="width: 60%">{{tr.namePay }}</div>
            <div class="col-td desktop"  style="width: 20%">{{tr.summa | toCurrency }}</div>
          </div>
        </template>
      </section>
      <div v-if="total.totalCount/limit > 1" class="container">
        <paginate
            :page-count="Math.ceil(total.totalCount/limit)"
            :click-handler="changePage"
            :page-range="4"
            :margin-pages="4"
            :initial-page="page"
            :prev-text="'Попередня'"
            :next-text="'Наступна'"
            :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{page * limit - limit + 1}} по {{pageTotal.countOnPage === Number(limit) ? page * limit :  total.totalCount }} із {{ total.totalCount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReportMenu from '../components/ReportMenu'
import Paginate from 'vuejs-paginate'
import  moment from "moment";
moment.defineLocale('uk', null)
export default {
  name: 'Payments',
  components: {
    ReportMenu,
    Paginate
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
    page: function () {
      // this.load = false
      this.getData()
    },
    limit: function () {
      // this.load = false
      this.getData()
      this.page = 1
    }
  },
  data() {
    return {
      load: false,
      payments: null,
      total: null,
      limit: 10,
      page: 1,
      pageTotal: {},
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
    }
  },
  created() {
    this.getData()
  },
  mounted () {

  },
  methods: {
    changePage: function (pageNum){
      this.page = pageNum
    },
    getData: function (){
        this.axios.get('/userservice/v1/User/payments', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00',  top: this.limit, page: this.page}})
      .then(
         (resp) => {
            this.payments = resp.data.data
            this.total = resp.data.total
            this.pageTotal = resp.data.pageTotal
          })
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>

</style>